export const promptEngineerConfig = {
    version: '1.0',
    source: 'ai_prompt_engineer',
    businessActionSelections: [],
    business: {
        industry: '',
        audience: '',
        description: '',
        additionalContext: '',
        descriptionSource: 'manual',
        descriptionSourceUrl: '',
        descriptionGeneratedAt: '',
        descriptionGenerationMeta: null
    },
    personality: {
        primary: '',
        secondary: '',
        communicationStyle: ''
    },
    behavior: {
        selectedBehaviors: [],
        uncertaintyHandling: '',
        offTopicHandling: ''
    },
    role: {
        mainJob: '',
        tasks: [],
        customTasks: '',
        taskApproach: ''
    },
    success: {
        goals: [],
        prohibitedActions: [],
        escalationTriggers: []
    }
};

export const promptEngineerPhaseTitles = [
    'Name Your Instructions.',
    'Tell Me About Your Business & Who Will Be Interacting With Your Agent.',
    'Let\'s Give Your Agent a Personality.',
    'How Should Your Agent Behave And Interact With Your Customers?',
    'What Jobs Will Your Agent Perform And How Should They Do It?',
    'Teach Your AI To Take Action.',
    'What Does Success Look Like?'
];

export const promptEngineerPhasePrompts = [
    'Start by naming this instruction set so it stays visible throughout the prompt engineer workflow.',
    'To engineer strong instructions, I need context about your business and who your agent will support.',
    'Great. Next, let\'s shape the voice and tone your users will experience in every response.',
    'Now define the behavior standards that should guide every interaction.',
    'Let\'s align on the core jobs your agent should perform and the approach it should take.',
    'Based on what you\'ve told me so far, let\'s decide whether your AI should be able to interact with your connected business systems.',
    'Final step: define success criteria, guardrails, and escalation moments.'
];

export const industryOptions = [
    'SaaS / Software',
    'Ecommerce',
    'Healthcare',
    'Legal',
    'Education',
    'Financial Services',
    'Real Estate',
    'Insurance',
    'Hospitality',
    'Nonprofit',
    'Government',
    'Internal Company Support',
    'IT / MSP',
    'Other'
];

export const audienceOptions = [
    'Customers',
    'Website visitors',
    'Leads / prospects',
    'Existing clients',
    'Employees',
    'Students',
    'Patients',
    'Members',
    'Vendors / partners',
    'Internal support team',
    'Other'
];

export const personalityOptions = [
    'Professional',
    'Friendly',
    'Warm',
    'Empathetic',
    'Direct',
    'Technical',
    'Conversational',
    'Formal',
    'Playful',
    'Calm',
    'Premium / polished'
];

export const communicationStyleOptions = [
    'Brief and efficient',
    'Helpful and conversational',
    'Detailed and educational',
    'Calm and reassuring',
    'Expert and confident',
    'Light and approachable'
];

export const behaviorOptions = [
    'Ask clarifying questions when needed',
    'Keep answers concise',
    'Provide step-by-step help',
    'Explain things in simple language',
    'Use bullet points when helpful',
    'Offer examples',
    'Confirm understanding before giving complex answers',
    'Avoid jargon',
    'Be proactive with next steps',
    'Stay focused on the user\'s question',
    'Admit when it does not know',
    'Never invent information',
    'Redirect off-topic questions politely'
];

export const uncertaintyHandlingOptions = [
    'Ask a clarifying question',
    'Say it does not know',
    'Recommend contacting support',
    'Escalate to a human',
    'Provide a cautious general answer only if appropriate'
];

export const offTopicHandlingOptions = [
    'Politely redirect to supported topics',
    'Answer briefly, then redirect',
    'Decline and redirect',
    'Escalate if needed'
];

export const mainJobOptions = [
    'Customer support',
    'Sales assistant',
    'Lead qualification',
    'Product expert',
    'Technical support',
    'Billing support',
    'Scheduling assistant',
    'Internal help desk',
    'HR assistant',
    'Student support',
    'Patient support',
    'Knowledge base assistant',
    'General website assistant',
    'Other'
];

export const taskOptions = [
    'Answer FAQs',
    'Troubleshoot issues',
    'Explain products or services',
    'Help users choose the right option',
    'Collect lead information',
    'Route users to the right department',
    'Explain pricing or plans',
    'Help with onboarding',
    'Provide policy information',
    'Summarize next steps',
    'Escalate complex issues',
    'Other'
];

export const taskApproachOptions = [
    'Answer directly first',
    'Ask questions first',
    'Walk users through steps',
    'Recommend the best option',
    'Provide choices',
    'Educate while solving',
    'Gather required information before escalating'
];

export const goalOptions = [
    'Resolve questions quickly',
    'Reduce support volume',
    'Improve customer experience',
    'Capture qualified leads',
    'Book appointments',
    'Help users find information',
    'Route users correctly',
    'Increase product understanding',
    'Improve onboarding',
    'Support internal teams'
];

export const prohibitedActionOptions = [
    'Invent answers',
    'Give legal advice',
    'Give medical advice',
    'Give financial advice',
    'Promise refunds',
    'Guarantee outcomes',
    'Discuss unsupported products',
    'Share confidential information',
    'Make account changes',
    'Collect sensitive information',
    'Answer outside the knowledge base',
    'Pretend to be human'
];

export const escalationTriggerOptions = [
    'User asks for a human',
    'User is upset or frustrated',
    'Billing/account-specific issue',
    'Legal, medical, financial, or compliance question',
    'Missing or unclear information',
    'Technical issue cannot be resolved',
    'Security/privacy concern',
    'Sales opportunity needs follow-up'
];
